/**
 * Encoder Types
 * Types for encoders, persistent streams, and probe results
 */

import type { EncoderStreamInfo } from './reports';

// ============================================================================
// Configuration
// ============================================================================

export const ENCODER_CONFIG = {
  /** Time since lastCommunication before showing warning state (1 hour) */
  STALE_WARNING_MS: 60 * 60 * 1000,
  /** Time since lastCommunication before showing stale/alert state (24 hours) */
  STALE_ALERT_MS: 24 * 60 * 60 * 1000,
} as const;

// ============================================================================
// Persistent Streams
// ============================================================================

export interface PersistentStreamResponse {
  psIndex: number;
  clientID: string; // Serialized from BigInt
  encoderID: string;
  title: string | null;
  LiveStreamURI: string | null;
  wcStreamID: string | null;
  // Encoder status fields
  status: number | null;             // 0=Offline, 1=Online, 2=Streaming
  lastCommunication: string | null;  // ISO date string
  streamInfo?: EncoderStreamInfo;    // bitrate, resolution, frameRate, etc.
}

export interface GetPersistentStreamsResponse {
  persistentStreams: PersistentStreamResponse[];
}

// ============================================================================
// Client Encoders
// ============================================================================

export interface ClientEncoderStreamInfoResponse {
  encoderID: string;
  streamInfo: string | null;
}

export interface ClientEncoderResponse {
  encoderID: string;
  clientID: string; // Serialized from BigInt
  simpleName: string;
  description: string | null;
  inputURI: string;
  streamName: string;
  lastCommunication: string | null; // ISO date string
  status: number | null;
  ingInstanceID: string | null;
  wcStreamID: string | null;
  streamInfo: ClientEncoderStreamInfoResponse | null;
}

export interface GetClientEncodersResponse {
  encoders: ClientEncoderResponse[];
}

